import { render, staticRenderFns } from "./suggestQuestion.vue?vue&type=template&id=4d383a26&scoped=true"
import script from "./suggestQuestion.vue?vue&type=script&lang=js"
export * from "./suggestQuestion.vue?vue&type=script&lang=js"
import style0 from "./suggestQuestion.vue?vue&type=style&index=0&id=4d383a26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d383a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d383a26')) {
      api.createRecord('4d383a26', component.options)
    } else {
      api.reload('4d383a26', component.options)
    }
    module.hot.accept("./suggestQuestion.vue?vue&type=template&id=4d383a26&scoped=true", function () {
      api.rerender('4d383a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/chat/widgets/suggestQuestion.vue"
export default component.exports